import { CountryIsoNumber } from '@domgen/dgx-fe-i18n';
import { ApplianceDetailsSteppedIpsFormValue } from '../../models/appliance-details-stepped/appliance-details-stepped-ips-form-value.type';

export const mockApplianceDetailsSteppedIpsFormValue: ApplianceDetailsSteppedIpsFormValue =
  {
    applianceCategoryCode: 'WM',
    applianceCode: 'CN',
    brandCode: 'AEG',
    modelAndSerialNumber: {
      modelNumber: null,
      serialNumber: null,
    },
    purchasePrice: '123',
    purchaseDate: new Date(
      'Wed Nov 06 2024 00:00:00 GMT+0000 (Greenwich Mean Time)'
    ),
    personalDetails: {
      ipsAddress: {
        search: 'search',
        address: {
          addressLine1: '350 W 37th St',
          addressLine2: 'Apt 1',
          city: 'New York',
          countryCode: String(CountryIsoNumber.UnitedStates),
          externalAVSAddressId: '8681990436',
          overrideAddress: false,
          postalCode: '10018-1234',
          regionOrStateCode: 'NY',
        },
      },
      firstName: '',
      lastName: '',
      emailAddress: '',
      telephoneNumber: '45435345',
      privacyPolicy: false,
    },
  };
